import { StyleSheet, Dimensions } from 'react-native';

const { width } = Dimensions.get('window');

const styles = StyleSheet.create({
  image: {
    alignSelf: 'center',
    height: '50%',
    paddingTop: 2,
    width,
  },
});

export default styles;

